import { Link, Popover, Tooltip, makeStyles } from '@material-ui/core'
import {
  Description as DescriptionIcon,
  Eco as EcoIcon,
} from '@material-ui/icons'
import clsx from 'clsx'
import sortBy from 'lodash/sortBy'
import React, { useState } from 'react'

import { Chip, SidePanel, Typography } from 'src/modules/ui'
import { formatDate } from 'src/utils'

const useStyles = makeStyles(theme => ({
  chip: {
    color: 'white',
    marginBottom: theme.spacing(1),
    marginRight: theme.spacing(1),
  },
  hasExtraIcon: {
    fontSize: '1rem',
    marginLeft: theme.spacing(0.5),
    marginBottom: -4,
    marginTop: -4,
  },
  popover: {
    padding: theme.spacing(2),
  },
  sustainabilityImage: {
    height: 50,
    objectFit: 'contain',
    marginBottom: theme.spacing(1),
    marginRight: theme.spacing(1),
    width: 50,
  },
  sustainabilityImageHasExtra: {
    cursor: 'pointer',
  },
  sustainabilityItems: {
    alignItems: 'center',
    display: 'flex',
    flexWrap: 'wrap',
  },
}))

const SustainabilityInfo = ({ className, Icon, sustainability }) => {
  const classes = useStyles()
  return (
    <SidePanel.Item title="Sustainability" Icon={EcoIcon}>
      <div className={classes.sustainabilityItems}>
        {sortBy(sustainability, ['image', 'name']).map(item => (
          <SustainabilityItem {...item} key={item.id} />
        ))}
      </div>
    </SidePanel.Item>
  )
}

const SustainabilityItem = ({ document, expiry, name, image }) => {
  const classes = useStyles()
  const [anchorEl, setAnchorEl] = useState(null)

  const handleClick = event => {
    setAnchorEl(event.currentTarget)
  }
  const handleClose = () => {
    setAnchorEl(null)
  }

  const hasExtra = document || expiry
  const open = Boolean(anchorEl)

  return (
    <>
      {image ? (
        <Tooltip enterDelay={500} title={name}>
          <img
            className={clsx(classes.sustainabilityImage, {
              [classes.sustainabilityImageHasExtra]: hasExtra,
            })}
            src={image}
            onClick={hasExtra ? handleClick : undefined}
            alt={name}
          />
        </Tooltip>
      ) : (
        <Chip
          color="lightGreen"
          label={
            <div>
              {name}
              {hasExtra && <DescriptionIcon className={classes.hasExtraIcon} />}
            </div>
          }
          size="small"
          className={classes.chip}
          onClick={hasExtra ? handleClick : undefined}
        />
      )}
      <Popover
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'center',
        }}
      >
        <div className={classes.popover}>
          <Typography variant="h5" color="darkGreen">
            {name}
          </Typography>
          <Typography>
            <Link href={document} target="_blank">
              Download Certificate
            </Link>
          </Typography>
          {expiry && (
            <Typography color="textSecondary" variant="body2">
              Expires: {formatDate(expiry)}
            </Typography>
          )}
        </div>
      </Popover>
    </>
  )
}

export default SustainabilityInfo
